<template>
  <div class="model-list-select">
    <input
      v-model="searchText"
      type="text"
      :placeholder="placeholder"
      class="form-control form-control-sm"
      @focus="open = true"
      @blur="onBlur"
    />
    <ul v-if="open && filtered.length" class="mls-dropdown">
      <li
        v-for="item in filtered"
        :key="item[optionValue]"
        @mousedown.prevent="select(item)"
        :class="{ active: modelValue === item[optionValue] }"
      >
        {{ item[optionText] }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ModelListSelect',
  props: {
    list: { type: Array, default: () => [] },
    modelValue: { type: [String, Number], default: null },
    optionValue: { type: String, default: 'id' },
    optionText: { type: String, default: 'name' },
    placeholder: { type: String, default: 'Search...' },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      searchText: '',
      open: false,
    };
  },
  computed: {
    filtered() {
      if (!this.searchText) return this.list;
      const q = this.searchText.toLowerCase();
      return this.list.filter(i => String(i[this.optionText]).toLowerCase().includes(q));
    },
  },
  watch: {
    modelValue(val) {
      const found = this.list.find(i => i[this.optionValue] === val);
      this.searchText = found ? found[this.optionText] : '';
    },
  },
  methods: {
    select(item) {
      this.$emit('update:modelValue', item[this.optionValue]);
      this.searchText = item[this.optionText];
      this.open = false;
    },
    onBlur() {
      setTimeout(() => { this.open = false; }, 150);
    },
  },
};
</script>

<style scoped>
.model-list-select { position: relative; }
.mls-dropdown {
  position: absolute; z-index: 9999; left: 0; right: 0;
  background: #fff; border: 1px solid #ddd;
  list-style: none; margin: 0; padding: 0;
  max-height: 200px; overflow-y: auto; border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,.12);
}
.mls-dropdown li { padding: 6px 10px; cursor: pointer; font-size: 13px; }
.mls-dropdown li:hover, .mls-dropdown li.active { background: #f0f4ff; }
</style>
